module.exports = __webpack_public_path__ + "static/img/img_21.f7041111.png";